export const forgotPasswordChanged = () => {
  return {
    title: 'Password Successfully Changed',
    subtitle_1: 'Please click on the link below and log in with your new credentials',
    log_in: 'Log In'
  }
}
